import * as $                        from 'jquery';
import { onClick, onLoad }           from 'Core/Events';
import { commonShowTarget }          from './CommonFunctions';

export const Sidenav = (() => {

    const Selector = {
        CATEGORY_ITEM:                     '.sidenav-list-item',
        CATEGORY_ARROW:                    '.arrow-cat-toggler',
        SIDENAV:                           '#sidenav',
        CURRENT_SUBCATEGORY:               '.current-subcat',
        SIDENAV_MOBILE_BTN:                '#js_sidenav_mobile'
    }

    onLoad(showCurrentCategoryExpanded);
    onClick(Selector.CATEGORY_ARROW, toggleCategoryHandler);
    onClick(Selector.SIDENAV_MOBILE_BTN, () => commonShowTarget(Selector.SIDENAV)) //for mobile version - show/hide categories component. Basicly, component is not visible.


    function showCurrentCategoryExpanded() { //open current, chosen category/subcategory
        const currentSubcategory = $(Selector.CURRENT_SUBCATEGORY).first();
        if (!currentSubcategory.length) {
            return;
        }

        const collapseElement = currentSubcategory.closest('ul.collapse');
        if (!collapseElement.length) {
            return;
        }

        const categoryItem = collapseElement.closest(Selector.CATEGORY_ITEM);
        const categoryArrow = categoryItem.find(Selector.CATEGORY_ARROW).first();
        const categoryLink = getCategoryLinkByArrow(categoryArrow);

        collapseElement.addClass('show');
        categoryLink.attr('aria-expanded', 'true');
        elementOpen(categoryArrow);
    }

    function toggleCategoryHandler() { //handler for category - arrows and show list of subcategories
        arrowChangeHandler(this);
        toggleCategoryExpanding(this);
    }


    function arrowChangeHandler(target) {
        const categoryArrow = $(target).closest(Selector.CATEGORY_ARROW);
        const categoryLink = getCategoryLinkByArrow(categoryArrow);

        if (categoryLink.attr('aria-expanded') == 'true') {
            elementClose(categoryArrow);
        } else {
            closeAllArrows();
            elementOpen(categoryArrow);
        }
    }


    function collapseOther() {  //used on category expanding handler before open current category
        $(Selector.SIDENAV).each(function (index, element) {
            $(element).find('[aria-expanded]').attr('aria-expanded', 'false');
            $(element).find('.collapse.show').collapse('hide');
        })
    }

    function closeAllArrows() {  //close all arrows. used on arrow handler before open clicked
        $(Selector.SIDENAV).each(function (index, element) {
            elementClose($(element).find(Selector.CATEGORY_ARROW));
        })
    }

    function toggleCategoryExpanding(target) { //handler for expanding category. Used on click per arrow
        const categoryArrow = $(target).closest(Selector.CATEGORY_ARROW);
        const categoryLink = getCategoryLinkByArrow(categoryArrow);
        const categoryCollapse = getCategoryCollapseByArrow(categoryArrow);

        if (categoryLink.attr('aria-expanded') == 'true') {
            categoryLink.attr('aria-expanded', 'false');
            categoryCollapse.collapse('hide');
        } else {
            collapseOther();
            categoryLink.attr('aria-expanded', 'true');
            categoryCollapse.collapse('show');
        }
    }

    function getCategoryLinkByArrow(categoryArrow) {
        return categoryArrow
            .closest(Selector.CATEGORY_ITEM)
            .find('> div a[aria-expanded], > a[aria-expanded]')
            .first();
    }

    function getCategoryCollapseByArrow(categoryArrow) {
        return categoryArrow
            .closest(Selector.CATEGORY_ITEM)
            .children('ul.collapse')
            .first();
    }

    function elementClose(element) { //handler for close arrow
        $(element)
            .removeClass('fa-chevron-up text-primary')
            .addClass('fa-chevron-down');
    }
    
    function elementOpen(element) { //handler for open arrow
        $(element)
            .removeClass('fa-chevron-down')
            .addClass('fa-chevron-up text-primary');
    }

})();
import * as $                        from 'jquery';
import { onClick, onLoad }           from 'Core/Events';
import { commonShowTarget }          from './CommonFunctions';

export const Sidenav = (() => {

    const Selector = {
        CATEGORY_ITEM:                     '.sidenav-list-item',
        CATEGORY_ARROW:                    '.arrow-cat-toggler',
        SIDENAV:                           '#sidenav',
        CURRENT_SUBCATEGORY:               '.current-subcat',
        SIDENAV_MOBILE_BTN:                '#js_sidenav_mobile'
    }

    onLoad(showCurrentCategoryExpanded);
    onClick(Selector.CATEGORY_ARROW, toggleCategoryHandler);
    onClick(Selector.SIDENAV_MOBILE_BTN, () => commonShowTarget(Selector.SIDENAV)) //for mobile version - show/hide categories component. Basicly, component is not visible.


    function showCurrentCategoryExpanded() { //open current, chosen category/subcategory
        const currentSubcategory = $(Selector.CURRENT_SUBCATEGORY).first();
        if (!currentSubcategory.length) {
            return;
        }

        const collapseElement = currentSubcategory.closest('ul.collapse');
        if (!collapseElement.length) {
            return;
        }

        const categoryItem = collapseElement.closest(Selector.CATEGORY_ITEM);
        const categoryArrow = categoryItem.find(Selector.CATEGORY_ARROW).first();
        const categoryLink = getCategoryLinkByArrow(categoryArrow);

        collapseElement.addClass('show');
        categoryLink.attr('aria-expanded', 'true');
        elementOpen(categoryArrow);
    }

    function toggleCategoryHandler() { //handler for category - arrows and show list of subcategories
        arrowChangeHandler(this);
        toggleCategoryExpanding(this);
    }


    function arrowChangeHandler(target) {
        const categoryArrow = $(target).closest(Selector.CATEGORY_ARROW);
        const categoryLink = getCategoryLinkByArrow(categoryArrow);

        if (categoryLink.attr('aria-expanded') == 'true') {
            elementClose(categoryArrow);
        } else {
            closeAllArrows();
            elementOpen(categoryArrow);
        }
    }


    function collapseOther() {  //used on category expanding handler before open current category
        $(Selector.SIDENAV).each(function (index, element) {
            $(element).find('[aria-expanded]').attr('aria-expanded', 'false');
            $(element).find('.collapse.show').collapse('hide');
        })
    }

    function closeAllArrows() {  //close all arrows. used on arrow handler before open clicked
        $(Selector.SIDENAV).each(function (index, element) {
            elementClose($(element).find(Selector.CATEGORY_ARROW));
        })
    }

    function toggleCategoryExpanding(target) { //handler for expanding category. Used on click per arrow
        const categoryArrow = $(target).closest(Selector.CATEGORY_ARROW);
        const categoryLink = getCategoryLinkByArrow(categoryArrow);
        const categoryCollapse = getCategoryCollapseByArrow(categoryArrow);

        if (categoryLink.attr('aria-expanded') == 'true') {
            categoryLink.attr('aria-expanded', 'false');
            categoryCollapse.collapse('hide');
        } else {
            collapseOther();
            categoryLink.attr('aria-expanded', 'true');
            categoryCollapse.collapse('show');
        }
    }

    function getCategoryLinkByArrow(categoryArrow) {
        return categoryArrow
            .closest(Selector.CATEGORY_ITEM)
            .find('> div a[aria-expanded], > a[aria-expanded]')
            .first();
    }

    function getCategoryCollapseByArrow(categoryArrow) {
        return categoryArrow
            .closest(Selector.CATEGORY_ITEM)
            .children('ul.collapse')
            .first();
    }

    function elementClose(element) { //handler for close arrow
        $(element)
            .removeClass('fa-chevron-up text-primary')
            .addClass('fa-chevron-down');
    }
    
    function elementOpen(element) { //handler for open arrow
        $(element)
            .removeClass('fa-chevron-down')
            .addClass('fa-chevron-up text-primary');
    }

})();
